import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=54b5c75a&scoped=true"
import script from "./classInfo.vue?vue&type=script&lang=js"
export * from "./classInfo.vue?vue&type=script&lang=js"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=54b5c75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5c75a",
  null
  
)

export default component.exports